var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 18C27 19.6547 25.6547 21 24 21H9.62344C8.82656 21 8.0625 20.6859 7.5 20.1234L0.439312 13.0594C0.158016 12.7781 0 12.3984 0 12C0 11.6016 0.158062 11.2219 0.439312 10.9406L7.5 3.87891C8.0625 3.31594 8.82656 3 9.62344 3H24C25.6547 3 27 4.34297 27 6V18ZM12.7031 9.75469L14.9109 12L12.7031 14.2031C12.2672 14.6438 12.2672 15.3563 12.7031 15.7547C13.1438 16.2328 13.8563 16.2328 14.2547 15.7547L16.5 13.5891L18.7031 15.7547C19.1437 16.2328 19.8563 16.2328 20.2547 15.7547C20.7328 15.3563 20.7328 14.6438 20.2547 14.2031L18.0891 12L20.2547 9.75469C20.7328 9.35625 20.7328 8.64375 20.2547 8.20312C19.8563 7.76719 19.1437 7.76719 18.7031 8.20312L16.5 10.4109L14.2547 8.20312C13.8563 7.76719 13.1438 7.76719 12.7031 8.20312C12.2672 8.64375 12.2672 9.35625 12.7031 9.75469Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteAll);
export default __webpack_public_path__ + "static/media/delete-all.863951cfcf38a20c20cb83a4423af8cc.svg";
export { ForwardRef as ReactComponent };